import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {S3Object}                                       from "../../API.service";
import {BehaviorSubject, Observable}                    from "rxjs";
import {Storage}                                        from "aws-amplify";
import {DateTime}                                       from "luxon";
import {SessionService}                                 from "../../services/session.service";
import {PermissionType}                                 from "../../../models";

@Component({
    selector: 'app-file-picker-item',
    templateUrl: './file-picker-item.component.html',
    styleUrls: ['./file-picker-item.component.css']
})
export class FilePickerItemComponent implements OnInit {

    @Output() uploadedFile: EventEmitter<any> = new EventEmitter<any>();

    @Input() name: string;
    @Input() file: S3Object | any;
    @Input() baseDir: string;
    @Input() label: string
    // Upload progress
    percentageVal: BehaviorSubject<number> = new BehaviorSubject<number>(-1);
    // Track file uploading with snapshot
    trackSnapshot: Observable<any>;

    // Uploaded File URL
    UploadedFileURL: Observable<string>;

    // File specifications
    fileName: string;
    fileSize: number;

    // File uploading status
    isFileUploading: boolean;
    isFileUploaded: boolean;
    private bucket: any;
    private region: any;

    constructor(public sessionService: SessionService) {
    }

    ngOnInit(): void {
        const x: any = Storage.getPluggable('AWSS3');

        this.region = x._config.region;
        this.bucket = x._config.bucket;
    }


    selectFile($event) {

        const element: HTMLElement = document.querySelector("input[name='" + this.name + "']") as HTMLElement;
        element.click();

    }

    async ionViewDidEnter() {
        console.log("file", this.file)
    }

    async uploadFile(event) {

        const file = event.target.files.item(0)

        // File validation
        /* if (file.type.split('/')[0] !== 'image') {

             return;
         }*/


        this.isFileUploading = true;
        this.isFileUploaded = false;

        this.fileName = file?.name;

        // Storage path
        const fileStoragePath = this.baseDir + `/${new Date().getTime()}_${this.name}` + "_" + this.fileName;
        let res: any = await Storage.put(fileStoragePath, file, {
            progressCallback: (progress) => {


                this.percentageVal.next(progress.loaded / progress.total);
            }
        });

        let f = {
            name: this.name,
            awsFile: {
                bucket: this.bucket, region: this.region, key: res.key, updateDate: DateTime.now().toString(),
                validated: this.sessionService.user?.permessions === PermissionType.ADMINISTRATOR
            }
        };

        await this.uploadedFile.emit(f);
        /*// Image reference
        const imageRef = this.afStorage.ref(fileStoragePath);

        // File upload task
        this.fileUploadTask = this.afStorage.upload(fileStoragePath, file);

        // Show uploading progress
        this.percentageVal = this.fileUploadTask.percentageChanges();
        this.trackSnapshot = this.fileUploadTask.snapshotChanges().pipe(
            finalize(() => {
                // Retreive uploaded image storage path
                this.UploadedFileURL = imageRef.getDownloadURL();

                this.UploadedFileURL.subscribe(resp => {
                    this.storeFilesFirebase({
                        name: file.name,
                        filepath: resp,
                        size: this.imgSize
                    });
                    this.isFileUploading = false;
                    this.isFileUploaded = true;
                }, error => {

                })
            }),
            tap(snap => {
                this.imgSize = snap.totalBytes;
            })
        )*/
    }

    setPercent(progress) {

        this.percentageVal.next(progress)
    }

    storeFiles(file: any) {

    }


    private uploadedFileFire(f: any) {
        this.uploadedFile.emit(f);
    }

    async openFile() {

        let f = await Storage.get(this.file.key);
        // @ts-ignore
        open(f);
    }

    async deleteFile() {
        if (confirm("Sicuro di voler eliminare il file?")) {
            let f = {
                name: this.name,
                awsFile: undefined
            };

            await this.uploadedFile.emit(f);
        }
    }

    async validate() {
        let file = JSON.parse(JSON.stringify(this.file));
        console.log(file);
        file.validated = true;
        let f = {
            name: this.name,
            awsFile: file
        };

        await this.uploadedFile.emit(f);
    }
}
